module.exports = __webpack_public_path__ + "odinstatic/media/third-party.507bfe40.svg";